const menus = [
  {
    key: "1",
    header: "基本设置",
    children: [
      {
        key: "1-1",
        title: "账号管理",
      },
      {
        key: "1-2",
        title: "地址管理",
      },
      {
        key: "1-3",
        title: "我的钱包",
        route: "/wallet",
      },
      // {
      //   key: "1-3",
      //   title: "邮箱管理",
      // },
    ],
  },
  // {
  //   key: "2",
  //   header: "安全设置",
  //   children: [
  //     {
  //       key: "2-1",
  //       title: "个人地址",
  //     },
  //     {
  //       key: "2-2",
  //       title: "隐私菜单",
  //     },
  //     {
  //       key: "2-3",
  //       title: "登录历史",
  //     },
  //     {
  //       key: "2-4",
  //       title: "账号注销",
  //     },
  //   ],
  // },
  // {
  //   key: "3",
  //   header: "参数设置",
  //   children: [
  //     {
  //       key: "3-1",
  //       title: "画质设置",
  //     },
  //     {
  //       key: "3-2",
  //       title: "音效设置",
  //     },
  //     {
  //       key: "3-3",
  //       title: "按键设置",
  //     },
  //   ],
  // },
];

export default menus;
